/* ============================================================
   KleenKick V3 — Slider B/A
   Drag pointer events + auto-glide la load + keyboard support
   ============================================================ */
(function () {
  'use strict';

  function initSlider(root) {
    const before = root.querySelector('[data-kk-ba-clip]');
    const handle = root.querySelector('[data-kk-ba-handle]');
    const frame = root.querySelector('.kk-ba__frame');
    if (!before || !handle || !frame) return;

    let position = 50; // %
    let isDragging = false;

    function setPosition(p) {
      position = Math.max(0, Math.min(100, p));
      before.style.clipPath = `polygon(0 0, ${position}% 0, ${position}% 100%, 0 100%)`;
      handle.style.left = `${position}%`;
      handle.setAttribute('aria-valuenow', Math.round(position));
    }

    function pointerToPosition(e) {
      const rect = frame.getBoundingClientRect();
      const x = (e.touches ? e.touches[0].clientX : e.clientX) - rect.left;
      return (x / rect.width) * 100;
    }

    function startDrag(e) {
      isDragging = true;
      root.classList.add('is-dragging');
      document.body.style.cursor = 'ew-resize';
      handleDrag(e);
    }

    function handleDrag(e) {
      if (!isDragging) return;
      e.preventDefault();
      setPosition(pointerToPosition(e));
    }

    function endDrag() {
      isDragging = false;
      root.classList.remove('is-dragging');
      document.body.style.cursor = '';
    }

    // Mouse
    handle.addEventListener('mousedown', startDrag);
    frame.addEventListener('mousedown', (e) => {
      // Allow clicking anywhere on frame to jump
      if (e.target === handle || handle.contains(e.target)) return;
      setPosition(pointerToPosition(e));
      startDrag(e);
    });
    window.addEventListener('mousemove', handleDrag);
    window.addEventListener('mouseup', endDrag);

    // Touch
    handle.addEventListener('touchstart', startDrag, { passive: true });
    window.addEventListener('touchmove', handleDrag, { passive: false });
    window.addEventListener('touchend', endDrag);
    window.addEventListener('touchcancel', endDrag);

    // Keyboard accessibility
    handle.addEventListener('keydown', (e) => {
      const step = e.shiftKey ? 10 : 2;
      if (e.key === 'ArrowLeft') { setPosition(position - step); e.preventDefault(); }
      else if (e.key === 'ArrowRight') { setPosition(position + step); e.preventDefault(); }
      else if (e.key === 'Home') { setPosition(0); e.preventDefault(); }
      else if (e.key === 'End') { setPosition(100); e.preventDefault(); }
    });

    // Auto-glide la load — sweep dramatic atrage atenția
    function autoGlide() {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      const sequence = [
        { to: 85, duration: 1100, ease: easeOutCubic },
        { to: 15, duration: 1400, ease: easeOutCubic },
        { to: 50, duration: 900, ease: easeOutCubic }
      ];

      let startPos = position;
      let stepIndex = 0;

      function animate(timestamp, startTime, fromPos, toPos, duration, ease) {
        const elapsed = timestamp - startTime;
        const progress = Math.min(1, elapsed / duration);
        const eased = ease(progress);
        setPosition(fromPos + (toPos - fromPos) * eased);

        if (progress < 1) {
          requestAnimationFrame((t) => animate(t, startTime, fromPos, toPos, duration, ease));
        } else if (stepIndex < sequence.length - 1) {
          stepIndex++;
          const next = sequence[stepIndex];
          const newFrom = position;
          requestAnimationFrame((t) => animate(t, t, newFrom, next.to, next.duration, next.ease));
        }
      }

      const first = sequence[0];
      requestAnimationFrame((t) => animate(t, t, startPos, first.to, first.duration, first.ease));
    }

    function easeOutCubic(t) { return 1 - Math.pow(1 - t, 3); }

    // Trigger auto-glide after loader done (or 200ms if no loader)
    document.addEventListener('kk:loaded', () => setTimeout(autoGlide, 400));
    if (document.body.classList.contains('is-loaded')) setTimeout(autoGlide, 400);

    // Init position
    setPosition(50);
  }

  document.querySelectorAll('[data-kk-ba]').forEach(initSlider);
})();
